import React, { useEffect, useRef } from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import Render from '../../../collums-components/components/formBuilder/render';
import Modal from '../../common/Modal';
import { FormProvider } from '../../../collums-components/hooks/forms';

const FormPreviewModal = ({ closeModal, formRef }) => {
    const contentRef = useRef(null);

    useEffect(() => {
        requestAnimationFrame(() => {
            const dialogContent = contentRef.current?.closest('.MuiDialogContent-root');
            if (dialogContent) {
                dialogContent.scrollTop = 0;
            }
        });
    }, []);

    return (
        <DndProvider backend={HTML5Backend}>
            <FormProvider
                value={{
                    isJourney: true,
                    defaultData: formRef.current
                }}
            >
                <Modal
                    id="form-preview-modal"
                    isOpen
                    title="Form Preview"
                    size="md"
                    onCancel={closeModal}
                    onClose={closeModal}
                >
                    <div ref={contentRef}>
                        <Render />
                    </div>
                </Modal>
            </FormProvider>
        </DndProvider>
    );
};

export default FormPreviewModal;
